import { createRoot } from "react-dom/client";
import App from "./App.tsx";
// Self-hosted webfonts. Must precede index.css so the @font-face rules are in
// the sheet before anything asks for 'Inter' or 'Poppins'.
import "./fonts.css";
import "./index.css";
import "./i18n";

createRoot(document.getElementById("root")!).render(<App />);
